import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Card, CardMedia, CardContent, Avatar } from '@material-ui/core';
import testNickPhoto from 'assets/img/landing/testimonials/nick.png';
import testSeannaPhoto from 'assets/img/landing/testimonials/seanna.png';
import testShelleyPhoto from 'assets/img/landing/testimonials/shelley.png';
import QuoteIcon from '@material-ui/icons/FormatQuote';

const useStyles = makeStyles(({ spacing, shadows, palette }) => ({
  root: {
    paddingTop: 64,
    paddingBottom: 64,
    margin: 0,
    width: '100%'
  },
  photo: {
    display: 'block',
    margin: 'auto'
  },
  card: {
    position: 'relative',
    margin: 'auto',
    maxWidth: 345
  },
  cardContent: {
    minHeight: 160
  },
  media: {
    height: 330
  },
  avatar: {
    position: 'absolute',
    width: 48,
    height: 48,
    color: palette.primary.contrastText,
    backgroundColor: palette.secondary.main,
    zIndex: 5,
    top: 306,
    right: 40,
    boxShadow: shadows[4]
  }
}));

const testimonials = [
  {
    name: 'Nick',
    image: testNickPhoto,
    md: 12,
    quote:
      'I went from 240 lbs to 190 lbs dropping from 26% to 8% bodyfat. BodyF1RST’s distinct approach was instrumental in helping me achieve this transformation.'
  },
  {
    name: 'Seanna',
    image: testSeannaPhoto,
    md: 4,
    quote:
      'Because of the training that Ken has provided I have made some major changes in my body, mind and spirit. I now have increased mobility and endurance.'
  },
  {
    name: 'Shelley',
    image: testShelleyPhoto,
    md: 4,
    quote:
      'My greatest achievement with this program is feeling better and getting stronger and continuing to improve me!'
  }
];

const SectionTestimonials = () => {
  const classes = useStyles({})
;
  return (
    <Grid
      id="testimonies"
      className={classes.root}
      container
      justify="center"
      alignContent="center"
      alignItems="center"
      spacing={3}
    >
      {testimonials.map(({ name, image, quote, md }) => (
        <Grid key={name} sm={12} lg={4} md={md} item>
          <Card className={classes.card}>
            <Avatar className={classes.avatar}>
              <QuoteIcon />
            </Avatar>

            <CardMedia className={classes.media} image={image} title={`${name} Testimonial`} />
            <CardContent className={classes.cardContent}>
              <Typography gutterBottom variant="h5" component="h2">
                {name}
              </Typography>
              <Typography variant="body2" color="textSecondary" component="p">
                “{quote}”
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default SectionTestimonials;
